import type { ListShadowItAppsResponse } from "../apps/-query/type";

/**
 * Shadow IT / Shadow ID の違反タイプ
 * API schema: components["schemas"]["ShadowItApp_4e53da6a"]["violationType"]
 */
export type ViolationType = NonNullable<
	ListShadowItAppsResponse["items"][number]["violationType"]
>;

export const ViolationType = {
	SHADOW_ACCESS: "SHADOW_ACCESS",
	SHADOW_ID: "SHADOW_ID",
} as const satisfies Record<string, ViolationType>;
